import { selectCurrentUser } from '@oneview/redux';
import { QuoteType, UserExchange, UserStatus, UserType } from '@orbis-systems/orbis-api-middleware';
import { useSelector } from 'react-redux';

export function useCurrentUser() {
    const user = useSelector(selectCurrentUser);
    const allowTipranks = user?.allowTipranks || false;
    const allowOptionTrading = user?.optionTrading || false;
    const quoteType = user?.quoteType || QuoteType.Delayed;
    const allowFractionals = user?.allowFractionals || false;
    const passwordStatus = user?.status || UserStatus.InitialPasswordChange;
    const username = user?.username || '';
    const associatedName = user?.associatedName || '';
    const email = user?.email;
    const phone = user?.associatedPhone;
    const userId = user?.userId;
    const allowMutualFunds = user?.allowMutualFunds ?? false;
    const allowTrailingStop = user?.allowTrailingStop ?? false;
    const allowLimit = user?.allowLimit ?? false;
    const allowLimitOnClose = user?.allowLoc || false;
    const allowLimitOnOpen = user?.allowLoo || false;
    const allowMarketOnClose = user?.allowMoc || false;
    const allowMarketOnOpen = user?.allowMoo || false;
    const allowStop = user?.allowStop ?? false;
    const isRealtime = quoteType !== QuoteType.Delayed; // same logic as in omni; might change, when we switch to Bill's quote source
    const allowSpreads = user?.allowSpreads ?? false;
    const allowBuyWrite = user?.allowBuywrites ?? false;
    const allowBondQuotes = user?.exchanges.includes(UserExchange.Bonds);
    const allowBondTrading = user?.allowBonds ?? false;
    const isBroker = user?.userType === UserType.Broker;
    const allowStopLimit = user?.allowStopLimit ?? false;
    const allowPrePost = user?.allowPrePost ?? false;
    const allowAllSessions = user?.allowAllSessions ?? false;
    const allowPreCoreSession = user?.allowPreCoreSession ?? false;
    const allowCorePostSession = user?.allowCorePostSession ?? false;
    const allowAlgos = user?.allowAlgos ?? false;
    const allowGtc = user?.allowGtc ?? false;
    const allowGtd = user?.allowGtd ?? false;
    const allowMarket = user?.allowMarket ?? false;
    const allowAon = user?.allowAon ?? false;

    return {
        allowTipranks,
        allowOptionTrading,
        quoteType,
        allowFractionals,
        passwordStatus,
        username,
        associatedName,
        email,
        phone,
        userId,
        allowMutualFunds,
        allowTrailingStop,
        allowLimit,
        allowLimitOnClose,
        allowLimitOnOpen,
        allowMarketOnClose,
        allowMarketOnOpen,
        allowStop,
        isRealtime,
        allowSpreads,
        allowBuyWrite,
        allowBondQuotes,
        allowBondTrading,
        isBroker,
        allowStopLimit,
        allowPrePost,
        allowAllSessions,
        allowPreCoreSession,
        allowCorePostSession,
        allowAlgos,
        allowGtc,
        allowGtd,
        allowMarket,
        allowAon,
    };
}
